import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { SideNavOuterToolbarModule, SingleCardModule } from './layouts';
import { AppFooterModule, CreateAccountFormModule } from './components';
import { AuthService, ScreenService, AppInfoService, ThemeService } from './services';
import { UnauthenticatedContentModule } from './unauthenticated-content';
import { AppRoutingModule } from './app-routing.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular'
import { CommonModule } from '@angular/common';
import { initializeKeycloak } from './services/initializeKeycloak.service';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient, withInterceptors,
} from '@angular/common/http';
import {AuthInterceptor} from './services/auth-interceptor.service';
import { EnvironmentService } from './services/environment.service';
import { DataInformationCardModule } from './components/library/data-information-card/data-information-card.component';
import { FormatDataValuePipeModule } from './pipes/format-data-value.pipe';
import { NgIconsModule } from '@ng-icons/core';

import devextremeAjax from 'devextreme/core/utils/ajax';
import { DxHttpModule } from 'devextreme-angular/http';

// icons
import {
  heroWallet,
  heroBanknotes,
  heroBriefcase,
  heroCreditCard

 } from '@ng-icons/heroicons/outline'

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    SideNavOuterToolbarModule,
    SingleCardModule,
    AppFooterModule,
    CreateAccountFormModule,
    UnauthenticatedContentModule,
    AppRoutingModule,
    KeycloakAngularModule,
    CommonModule,
    DataInformationCardModule,
    FormatDataValuePipeModule,
    NgIconsModule.withIcons({
      heroWallet,
      heroBanknotes,
      heroBriefcase,
      heroCreditCard
    }),
    DxHttpModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthService,
    ScreenService,
    AppInfoService,
    ThemeService,
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, EnvironmentService],
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
